import If from "../../if"
import useConversationChatBox from "../use-conversation-chat-box"
import AIFooter from "./ai"
import LOFooter from "./lo"

const Footer = () => {
  const {
    takeOverFlag,
    takeOverConversation,
    sendReply,
    message,
    setReplyMessage
  } = useConversationChatBox()

  return (
    <div className="bg-white px-4 py-3">
      <If
        condition={takeOverFlag}
        then={
          <LOFooter
            takeOverConversation={takeOverConversation}
            sendReply={sendReply}
            message={message}
            setReplyMessage={setReplyMessage}
          />
        }
        else={<AIFooter takeOverConversation={takeOverConversation} />}
      />
    </div>
  )
}

export default Footer
